export default __webpack_public_path__ + "static/media/PEGI_16.49a8f64d.svg";